"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bson_1 = require("bson");
var pasteparserv1_1 = require("./pasteparserv1");
var pasteparserv2_1 = require("./pasteparserv2");
var pasteparserv3_1 = require("./pasteparserv3");
var PasteParser = /** @class */ (function () {
    function PasteParser() {
    }
    PasteParser.parse = function (name, key, data) {
        var parser;
        var pasteData;
        if (typeof data === 'string') {
            pasteData = JSON.parse(data);
            if (pasteData.version === undefined) {
                parser = new pasteparserv1_1.default();
            }
            else if (pasteData.version === 2) {
                parser = new pasteparserv2_1.default();
            }
            else {
                throw new Error("Unknown paste API version: \"" + pasteData.version + "\".");
            }
        }
        else {
            var bson = new bson_1.BSON();
            pasteData = bson.deserialize(data);
            if (pasteData.version === 3) {
                parser = new pasteparserv3_1.default();
            }
            else {
                throw new Error("Unknown paste API version: \"" + pasteData.version + "\".");
            }
        }
        return parser.parse(name, key, pasteData);
    };
    return PasteParser;
}());
exports.default = PasteParser;
